import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss']
})
export class ImpressumComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  public text= companyInfo;

}
